import React from "react";
import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as Close } from "../../assets/icons/close.svg";

type CommonModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  changeWidthandHeight?: boolean;
  crossClass: string;
};

const ModalWithoutTitle: React.FC<CommonModalProps> = ({
  isOpen,
  onClose,
  children,
  changeWidthandHeight,
  crossClass,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div
        className={`bg-white rounded-lg shadow-lg p-4 ${changeWidthandHeight ? "" : "max-w-lg w-full"}  max-h-[90vh]  z-10`}
      >
        <div className="relative">
          <button
            onClick={onClose}
            className={`text-black hover:text-gray-700 ${crossClass && crossClass} absolute text-3xl cursor-pointer z-[100]`}
          >
            <span>&times;</span>
          </button>
        </div>
        <div className="overflow-y-auto max-h-[80vh] scroller">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default ModalWithoutTitle;
